import {Share} from 'react-native';
import type {TFunction} from 'i18next';

/**
 * Hand an invite to a person. Deliberately the OS share sheet and nothing else:
 * a recipient is usually reached over another messenger, and the share sheet is
 * built into React Native — a QR or clipboard library would mean a native
 * dependency and a fresh APK toolchain pass for no reach we don't already have.
 *
 * When the server has no TELEGRAM_BOT_USERNAME configured, `deepLink` comes back
 * empty; we share the /start command instead so the flow still completes by hand.
 */
export async function shareInvite(
  t: TFunction,
  {deepLink, code}: {deepLink: string; code: string},
): Promise<void> {
  const message = deepLink
    ? t('telegram.shareMessage', {link: deepLink})
    : t('telegram.shareCodeMessage', {code});
  try {
    await Share.share({message});
  } catch {
    // The user dismissed the sheet, or the platform refused it. Nothing to
    // recover: the code stays visible on screen and stays valid.
  }
}
